import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import FeatureHeroBenefits from "@/components/FeatureHeroBenefits"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { gtmTracking } from "@/utils/gtm-tracking"

const PPCHeader = ({
  className = "",
  buttonClassName,
  kickerText,
  title,
  titleClass,
  description,
  image,
  primaryButtonText,
  primaryButtonAction,
  benefitsTitle,
  benefitsItems,
}) => {
  return (
    <section className={`primary-header ${className}`}>
      <div className="container-fluid row middle-sm between-md">
        <div className="col-xs-12 col-sm col-md-5 mt-10 sm:mt-0 mb-5 sm:mb-0 primary-header__content ppc-header__text">
          {kickerText && (
            <span className="heading-kicker pt-10 md:pt-0">{kickerText}</span>
          )}
          <h1 className={titleClass}>{title}</h1>
          {description && <p className="p--lg">{description}</p>}

          <div className="primary-header__buttons">
            {primaryButtonAction && primaryButtonAction}
            {primaryButtonText && (
              <Link
                to="/signup/"
                className={`btn  ${buttonClassName}`}
                onClick={() => gtmTracking("CTA Click", "Try Free", "Hero")()}
              >
                {primaryButtonText}
              </Link>
            )}
          </div>
        </div>
        <div className="mt-10 col-xs-12 col-md-5 col-md-offset-2 primary-header__asset">
          <div className="pb-10 sm:pb-16 pr-10 vs:pr-16 sm:pr-0">
            <div className="feature-hero__ppc">
              <GatsbyImage
                image={getImage(image.src)}
                alt={image.alt}
                imgClassName="primary-header__image"
              />
              <FeatureHeroBenefits
                title={benefitsTitle}
                items={benefitsItems}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PPCHeader
